import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGPLogo from "@assets/images/SCGP-color.svg";
import HeadColored from "@saleor/components/HeadColored";
import React from "react";

import useStyles from "./styles";

interface PlainLayoutProps {
  children: React.ReactNode;
}

const PlainLayout: React.FC<PlainLayoutProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeadColored fixedTop />
      <div className={classes.mainPanel}>
        <div className={classes.headTextLogo}>
          <div className={classes.text}>
            <img src={SCGPLogo} alt={"logo"} />
          </div>
          <div className={classes.logo}>
            <img src={EOrderingLogo} alt={"logo"} />
          </div>
        </div>
        <div>{children}</div>
      </div>
      <footer className={classes.footer}>
        COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
      </footer>
    </div>
  );
};

export default PlainLayout;
